export default __webpack_public_path__ + "static/media/traverse-detailed-logo.b24c8411.svg";